// extracted by mini-css-extract-plugin
export default {"productCarousel":"R5-z"};